<template>
  <div class="flex flex-col gap-3">
    <ViewSelector v-model:view="localDisplayOptions.view" :views="views" />
    <TimelineOption
      v-if="
        [
          'resourceTimelineDay',
          'resourceTimelineThreeDays',
          'resourceTimelineWeek'
        ].includes(localDisplayOptions.view)
      "
      v-model:timeline-group-by="localDisplayOptions.timelineGroupBy"
      v-model:timeline-location-filter="
        localDisplayOptions.timelineLocationFilter
      "
      :selected-view="localDisplayOptions.view"
      :views="views"
    />
    <div class="flex gap-4">
      <TimeSelector v-model:slot-time="localDisplayOptions.slotTime" />
      <SlotDurationSelector
        v-model:slot-duration="localDisplayOptions.slotDuration"
      />
    </div>
    <div class="flex flex-row gap-4">
      <label class="flex cursor-pointer items-center gap-2 text-sm">
        <input
          v-model="localDisplayOptions.compactView"
          type="checkbox"
          class="rounded"
        />
        {{ $t('global.view_compact') }}
      </label>
      <label class="flex cursor-pointer items-center gap-2 text-sm">
        <input
          v-model="localDisplayOptions.colorByDeceased"
          type="checkbox"
          class="rounded"
        />
        {{ $t('global.color_by_deceased') }}
      </label>
    </div>
  </div>
</template>

<script>
import ViewSelector from '@c/Dashboard/Content/Agenda/Panel/ViewSelector.vue'
import TimeSelector from '@c/Dashboard/Content/Agenda/Panel/TimeSelector.vue'
import SlotDurationSelector from '@c/Dashboard/Content/Agenda/Panel/SlotDurationSelector.vue'
import TimelineOption from '@c/Dashboard/Content/Agenda/Panel/TimelineOption.vue'

let default_display_options = {
  view: 'timeGridWeek',
  slotTime: {
    min: '06:00:00',
    max: '20:00:00'
  },
  slotDuration: '00:15:00',
  timelineGroupBy: 'location',
  timelineLocationFilter: ['FPR'],
  compactView: false,
  colorByDeceased: false
}

export default {
  name: 'DisplayOptionsContent',
  components: {
    TimelineOption,
    SlotDurationSelector,
    TimeSelector,
    ViewSelector
  },
  props: {
    displayOptions: {
      type: Object,
      required: true
    }
  },
  emits: ['update:displayOptions'],
  data() {
    return {
      localDisplayOptions: {
        ...default_display_options,
        ...(this.displayOptions || {})
      },
      views: [
        {
          label: this.$t('global.button.dashboard.agenda.jour'),
          icon: 'calendar-day',
          gate: true,
          type: 'timeGridDay'
        },
        {
          label: this.$t('global.button.dashboard.agenda.semaine'),
          icon: 'calendar-week',
          gate: true,
          type: 'timeGridWeek'
        },
        {
          label: this.$t('global.button.dashboard.agenda.mois'),
          icon: 'calendar-days',
          gate: true,
          type: 'dayGridMonth'
        },
        {
          label: this.$t('global.button.dashboard.agenda.timeline_jour'),
          icon: 'list-timeline',
          gate: true,
          type: 'resourceTimelineDay'
        },
        {
          label: this.$t('global.button.dashboard.agenda.timeline_3_jours'),
          icon: 'list-timeline',
          gate: true,
          type: 'resourceTimelineThreeDays'
        },
        {
          label: this.$t('global.button.dashboard.agenda.timeline_7_jours'),
          icon: 'list-timeline',
          gate: true,
          type: 'resourceTimelineWeek'
        }
      ]
    }
  },
  watch: {
    localDisplayOptions: {
      handler(newValue) {
        this.$emit('update:displayOptions', newValue)
      },
      deep: true
    }
  }
}
</script>
